import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { services, videos } from '../data/mock';

const ServicesSection = () => {
  return (
    <section id="services" className="py-16 lg:py-24 bg-white" aria-labelledby="services-heading">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 id="services-heading" className="text-3xl sm:text-4xl font-display font-semibold mb-4" style={{ color: '#c49bc4' }}>
            Our Home Care Services in Columbus, Ohio
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Non-medical home care services tailored to individual needs, delivered with compassion and professionalism throughout Columbus, Ohio.
          </p>
        </div>
        
        {/* Video Feature Section */}
        <div className="mb-12 grid lg:grid-cols-2 gap-8 items-center">
          <div className="video-container aspect-video rounded-2xl overflow-hidden shadow-xl">
            <video 
              autoPlay 
              muted 
              loop 
              playsInline
              preload="metadata"
              className="w-full h-full object-cover"
              width="640"
              height="360"
              aria-label="Video showcasing our compassionate home care services"
            >
              <source src={videos.about} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div>
            <h3 className="text-2xl font-display font-semibold mb-4" style={{ color: '#008080' }}>
              Personalized Care You Can Trust
            </h3>
            <p className="text-gray-600 leading-relaxed mb-4">
              Our trained and compassionate caregivers provide individualized attention to each client. 
              We understand that every person has unique needs, and we tailor our services accordingly.
            </p>
            <p className="text-gray-600 leading-relaxed">
              From daily assistance to meaningful companionship, we&apos;re here to help your loved ones 
              maintain their independence and quality of life in the comfort of their own home.
            </p>
          </div>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, index) => (
            <article 
              key={service.id} 
              className="service-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <img 
                src={service.image} 
                alt={`${service.title} - Non-medical home care service in Columbus, Ohio`}
                className="service-card-image"
                loading="lazy"
                width="400"
                height="225"
              />
              <h3 className="text-xl font-semibold mb-3" style={{ color: '#008080' }}>
                {service.title}
              </h3>
              <p className="text-gray-600 mb-4 leading-relaxed">
                {service.description}
              </p>
              <Link 
                to={`/services/${service.slug}`}
                className="inline-flex items-center gap-2 font-medium transition-colors hover:gap-3"
                style={{ color: '#008080' }}
                aria-label={`Learn more about ${service.title} home care services`}
              >
                Learn More <ArrowRight className="w-4 h-4" aria-hidden="true" />
              </Link>
            </article>
          ))}
        </div>

        {/* View All Services Link */}
        <div className="text-center mt-10">
          <Link 
            to="/services"
            className="btn-primary inline-flex items-center gap-2 px-8 py-3"
          >
            View All Services
            <ArrowRight className="w-4 h-4" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
